'use strict';

var FORM_SELECTOR  = '#trackorder-form';
var INPUT_SELECTOR = '#trackorder-form-number';
var ERROR_SELECTOR = '#form-number-error';

/**
 * Normalize input value to uppercase, validate prefix,
 * update UI feedback while typing
 * @param {jQuery} $input - jQuery object for the input field
 * @param {jQuery} $error - jQuery object for the error message container
 * @returns {boolean} - always true to allow html5 validation to handle the rest
 */
function normalizeAndValidateOrderNumberInput($input, $error) {
    if (!$input || !$input.length) return true;

    var rawValue = ($input.val() || '').toString();
    var upperValue = rawValue.toUpperCase().trim();
    var isValidPrefix = /^[ijmp][0-9]+$/i.test(upperValue);
    var validationMessage = $input.data('pattern-mismatch');

    if (rawValue !== upperValue) {
        $input.val(upperValue);
    }

    if ($input[0]) $input[0].setCustomValidity(isValidPrefix ? '' : validationMessage);
    $input.toggleClass('is-invalid', !isValidPrefix).attr('aria-invalid', isValidPrefix ? null : 'true');

    if ($error && $error.length) {
        if (isValidPrefix) {
            $error.empty();
        } else {
            $error.text(validationMessage).show();
        }
    }

    return true;
}

function attachOrderLookupValidation() {
    var $form = $(FORM_SELECTOR);
    var $submit = $form.find('.track-submit');
    var $input = $(INPUT_SELECTOR);
    var $error = $(ERROR_SELECTOR);

    if (!$form.length || !$input.length) {
        return; // form not present, do nothing
    }

    $input.on('input', function () {
        normalizeAndValidateOrderNumberInput($input, $error);
    });

    $submit.on('click', function (e) {
        if (!normalizeAndValidateOrderNumberInput($input, $error) || !this.checkValidity()) {
            e.preventDefault();
            e.stopPropagation();
            $input.trigger('focus');
            $form.addClass('was-validated');
        } else {
            $form.removeClass('was-validated');
        }
    });
}

module.exports = function initializeOrderLookupValidation() {
    attachOrderLookupValidation();
};
